<template>
  <button class="badge grid-x align-middle small" :aria-label="`${label} badge`">
    {{ label }}
  </button>
</template>

<script setup lang="ts">
defineProps<{
  label: string;
}>();
</script>
<style lang="scss" scoped>
@import '~settingSCSS';

.badge {
  background-color: $hover-color;
  position: relative;
  padding: rem-calc(3 8);
}
</style>
